const hasPermission = (permissions = [], scopes = []) => {
  const scopesMap = {};
  scopes.forEach(scope => {
    scopesMap[scope] = true;
  });

  return permissions.some(permission => scopesMap[permission]);
};
export default hasPermission;
